Cookiebar = {
    bar: {},
    agreeAll: false,

    savedCookieName: 'closedEuCookieBar',

    init: function() {
        Cookiebar.bar =  $('div.euCookies');

        if(Cookies.get(Cookiebar.savedCookieName)) {
            // Nezmazat z DOMu nastavenia ktore su na stranke /cookies
            Cookiebar.bar.filter(":not(.visible)").remove();
            Cookiebar.bar =  $('div.euCookies');
        }

        Cookiebar.bar.find("input.cookie-agree").each(function() {
            var cookieName = $(this).attr('cookie-name');

            if (parseInt(Cookies.get(cookieName)) === 0) {
               $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });

        var okButton = $(Cookiebar.bar).find('a.button.agree');
        okButton.on('click', Cookiebar.saveSettings);

        var settingsButton = $(Cookiebar.bar).find('a.button.settings');
        settingsButton.on('click', Cookiebar.openSettings);

        var saveButton = $(Cookiebar.bar).find('a.block.button.save');
        saveButton.on('click', Cookiebar.saveSettings);

        Cookiebar.view();
    },

    openSettings: function(button) {
        var settings = $('.euCookies .cell.settings');

        if (settings.is('.expanded')) {
            settings.slideUp(300);
            settings.removeClass('expanded');
            $(button.target).removeClass('expanded');
        } else {
            settings.slideDown(300);
            settings.addClass('expanded');
            $(button.target).addClass('expanded');
        }
        
    },

    saveAgreeAll: function() {
        if (Cookiebar.bar.is('.old'))
            Cookiebar.close();
        else
            Cookiebar.saveSettings(undefined, true);
    },

    saveSettings: function(event, agreeAll) {
        console.log('agreeAll', agreeAll);
        Cookiebar.agreeAll = agreeAll === undefined ? false : agreeAll;

        Cookiebar.bar.find('input.cookie-agree').each(function(index) {
            var cookieName = $(this).attr('cookie-name');
            var cookieSetting = $(this).is(':checked') ? 1 : 0;

            // console.log('cookie set', cookieSetting);

            Cookies.set(cookieName, Cookiebar.agreeAll == true ? 1 : cookieSetting, {expires: 365});
        });

        Cookiebar.bar.find(".cookies-saved").addClass("show");
        setTimeout(function() {
            Cookiebar.bar.find(".cookies-saved").removeClass("show");
        }, 3000);

        Cookiebar.close();
    },

    view: function(){

        if((Cookies.get(Cookiebar.savedCookieName) && !Cookiebar.bar.is(".new-cookie")) || (Cookies.get(Cookiebar.savedCookieName + "NEW") && Cookiebar.bar.is(".new-cookie"))) {
            return;
        }        

        Cookiebar.bar.css({display: 'block', opacity: 0 });
        var height = Cookiebar.bar.height();

        Cookiebar.bar.height(0);
        setTimeout(function(){Cookiebar.bar.css({opacity: 1}) });

        Cookiebar.bar.stop().delay(1000).animate({height: height}, 500, function(){
            $(this).css({height: ''});
        });
    },
    
    close: function(){
        $('div.euCookies:not(.visible)').stop().delay(100).animate({height:0},500, function(){
            $(this).remove(); 
        })
         
        Header.resize();
        Cookies.set(Cookiebar.savedCookieName, 1, {expires: 365});

        location.reload();
    }
}